"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBlockMovingModeClassNames = useBlockMovingModeClassNames;

var _classnames = _interopRequireDefault(require("classnames"));

var _data = require("@wordpress/data");

/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */

/**
 * Returns the class names used for block moving mode.
 *
 * @param {string} clientId The block client ID to insert above.
 *
 * @return {string} The class names.
 */
function useBlockMovingModeClassNames(clientId) {
  return (0, _data.useSelect)(function (select) {
    var _select = select('core/block-editor'),
        hasBlockMovingClientId = _select.hasBlockMovingClientId,
        canInsertBlockType = _select.canInsertBlockType,
        getBlockName = _select.getBlockName,
        getBlockRootClientId = _select.getBlockRootClientId,
        isBlockSelected = _select.isBlockSelected; // The classes are only relevant for the selected block. Avoid
    // re-rendering all blocks!


    if (!isBlockSelected(clientId)) {
      return;
    }

    var movingClientId = hasBlockMovingClientId();

    if (!movingClientId) {
      return;
    }

    return (0, _classnames.default)('is-block-moving-mode', {
      'can-insert-moving-block': canInsertBlockType(getBlockName(movingClientId), getBlockRootClientId(clientId))
    });
  }, [clientId]);
}
//# sourceMappingURL=use-block-moving-mode-class-names.js.map